//function common header crm links
export const productDetailsHeaderLinks = (id, t) => {
  return [
    { title: t("Vital Info"), link: `/admin/marketplace/information/${id}` },
    { title: t("Attributes"), link: `/admin/marketplace/information/${id}` },
  ];
};
